import React from 'react';
import styled from 'styled-components';
import { Outlet } from 'react-router-dom';
import MainMenuView from '@/main/view/MainMenuView';

const Main = styled.main`
  overflow: auto;
  flex: 1;
  min-width: 0;
`;

const MainLayout: React.FC = () => {
  return (
    <div className="app">
      <MainMenuView />
      <Main>
        <Outlet />
      </Main>
    </div>
  );
};

export default MainLayout;
